export enum CACHE_ID_TYPE {
  AfterMessageCacheId = "afterMessageCacheId",
  BeforeMessageCacheId = "beforeMessageCacheId"
}
